import addMixinName from './addMixinName'
import addMixinProp from './addMixinProp'
import getMixinMethods from './getMixinMethods'
import getMixinName from './getMixinName'
import hasMethod from './hasMethod'
import hasMixin from './hasMixin'
import runInit from './runInit'

export default {addMixinName,addMixinProp,getMixinName,getMixinMethods,hasMethod,hasMixin,runInit}